import { render, staticRenderFns } from "./Login.iframe.component.vue?vue&type=template&id=c9e7e4f6"
import script from "./Login.iframe.component.vue?vue&type=script&lang=js"
export * from "./Login.iframe.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports